import React from 'react';
import { Row, Alert } from 'antd';
import { FormField, maxLength } from 'common';
import {
  SearchTypeFormNames,
  TaxTraxFormLabels,
  AddressSearchFormNames,
  OwnerSearchFormNames,
} from './TaxTrax.constants';
import styles from './TaxTrax.module.scss';
import globalStyles from 'common/global.module.scss';
import { GetDriversResult } from './models';

const warnText = [maxLength(20)];

interface Props {
  handleFieldFocus: any;
  driversData: GetDriversResult;
}

const TaxTraxFormTabs: React.FC<Props> = ({
  handleFieldFocus,
  driversData,
}) => {
  return (
    <>
      <Row type="flex">
        <FormField
          className={`m-0`}
          name={SearchTypeFormNames.SEARCH_BY}
          inputType="radio"
          value={SearchTypeFormNames.ADDRESS_SEARCH}
        >
          {TaxTraxFormLabels.ADDRESS_SEARCH}
        </FormField>
      </Row>
      <Row type="flex" align="middle" className={globalStyles.row}>
        <FormField
          tabIndex="100"
          onFocus={handleFieldFocus}
          label={TaxTraxFormLabels.HOUSE}
          name={AddressSearchFormNames.HOUSE}
          className={globalStyles.input}
        />
        <FormField
          tabIndex="200"
          onFocus={handleFieldFocus}
          warn={warnText}
          label={TaxTraxFormLabels.STREET}
          name={AddressSearchFormNames.STREET}
          className={globalStyles.input}
        />
      </Row>
      <Row type="flex">
        <FormField
          className={`m-0`}
          name={SearchTypeFormNames.SEARCH_BY}
          inputType="radio"
          value={SearchTypeFormNames.OWNER_SEARCH}
        >
          {TaxTraxFormLabels.OWNER_SEARCH}
        </FormField>
      </Row>
      <Row type="flex" align="middle" className={globalStyles.row}>
        <FormField
          tabIndex="300"
          onFocus={handleFieldFocus}
          warn={warnText}
          label={TaxTraxFormLabels.LAST_CORP}
          name={OwnerSearchFormNames.LAST_CORP}
          className={globalStyles.input}
        />
        <FormField
          tabIndex="400"
          onFocus={handleFieldFocus}
          warn={warnText}
          label={TaxTraxFormLabels.FIRST}
          name={OwnerSearchFormNames.FIRST}
          className={globalStyles.input}
        />
        <FormField
          tabIndex="500"
          onFocus={handleFieldFocus}
          warn={warnText}
          label={TaxTraxFormLabels.MIDDLE}
          name={OwnerSearchFormNames.MIDDLE}
          className={globalStyles.input}
        />
      </Row>
      <Row type="flex">
        <FormField
          className={`m-0`}
          name={SearchTypeFormNames.SEARCH_BY}
          inputType="radio"
          value={SearchTypeFormNames.DRIVERS_SEARCH}
        >
          {TaxTraxFormLabels.DRIVERS_SEARCH}
        </FormField>
      </Row>

      <Row type="flex" align="middle" className={globalStyles.row}>
        {driversData && driversData.drivers && !!driversData.drivers.length ? (
          driversData.drivers.map(
            ({ guid, fIndex, name, specialCharacter }) => {
              return (
                <React.Fragment key={guid}>
                  <FormField
                    onFocus={handleFieldFocus}
                    warn={warnText}
                    label={name}
                    name={`${SearchTypeFormNames.DRIVERS_SEARCH}.${fIndex}`}
                    className={`${globalStyles.input} ${
                      !name && styles.noLabel
                    }`}
                  />
                  {specialCharacter && (
                    <span className={styles.specialCharacter}>
                      {specialCharacter}
                    </span>
                  )}
                </React.Fragment>
              );
            },
          )
        ) : (
          <Alert
            className="w-100"
            message={`Please select County or City/Town or Village to proceed with search.`}
            type="warning"
          />
        )}
      </Row>
    </>
  );
};

export default TaxTraxFormTabs;
